module.exports = __webpack_public_path__ + "img/ic_marker_asset_cluster.644abc7b.png";